import {gql, useMutation, useQuery} from '@apollo/client'
import {useState} from 'react'
import {useAlert} from 'react-alert'
import {getGraphQLErrorMessage} from '~/util'
import {UPDATE_IMPORT_CONFIG} from '../ManageFields/useManageFields'

export const FILTER_DATA = gql`
    query FilterData($dataSourceIdStr: String!) {
        dataSource(dataSourceIdStr: $dataSourceIdStr) {
            importConfig {
                filterRules
            }
        }
    }
`

export type ManageFiltersState = {
    modal: string
    filterRulesText: string
    loading: boolean
    saving: boolean
}

export default function useManageFilters(dataSourceIdStr: string) {
    const alert = useAlert()
    const [modal, setModal] = useState('')
    const [filterRulesText, setFilterRulesText] = useState('')

    const {data, loading, refetch} = useQuery(FILTER_DATA, {
        variables: {dataSourceIdStr},
        skip: !dataSourceIdStr,
    })

    const [updateImportConfig, {loading: saving}] = useMutation(UPDATE_IMPORT_CONFIG, {
        onError: (error) => alert.error(getGraphQLErrorMessage(error)),
    })

    const openManageFilters = () => {
        const rules = data?.dataSource?.importConfig?.filterRules || []
        setFilterRulesText(rules.join('\n'))
        setModal('manageFilters')
    }

    const saveFilterRules = async () => {
        const filterRules = filterRulesText
            .split('\n')
            .map((line) => line.trim())
            .filter(Boolean)

        await updateImportConfig({
            variables: {
                dataSourceIdStr,
                importConfig: {filterRules},
            },
        })
        await refetch()
        setModal('')
    }

    const state: ManageFiltersState = {modal, filterRulesText, loading, saving}

    return {
        state,
        actions: {
            setModal,
            setFilterRulesText,
            openManageFilters,
            saveFilterRules,
        },
    }
}
